var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-row',{staticClass:"home-block-title-wrap"},[_c('div',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',{staticClass:"more"},[_c('router-link',{attrs:{"to":_vm.link,"tag":"div"}},[_c('span',[_vm._v(_vm._s(_vm.linkText))])])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }